module.exports = function(){ /* empty */ };


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/~/core-js/library/modules/$.unscope.js
 **/